import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
export var Headings;
(function (Headings) {
    Headings["H1"] = "h1";
    Headings["H2"] = "h2";
    Headings["H3"] = "h3";
    Headings["H4"] = "h4";
    Headings["H5"] = "h5";
    Headings["H6"] = "h6";
})(Headings || (Headings = {}));
export var Heading = function (props) {
    var headingName = (props.level || "span").toLowerCase();
    var clazzName = joinClasses(props.headingStyle ? "scl-b-h scl-b-" + props.headingStyle : undefined, props.className);
    return (React.createElement("".concat(headingName), { className: clazzName }, props.children));
};
